<h1 mat-dialog-title class="dialog-title margin-0">{{data.title}}</h1>
<div mat-dialog-content>
  <div *ngIf="!data.messages || data.messages.length === 0" class="conversation-status">
    No conversation found
  </div>
  <div *ngIf="data.messages && data.messages.length > 0" class="conversation-messages">
    <div *ngFor="let message of data.messages"
         class="conversation-row"
         [class.conversation-row-agent]="message.side === 'agent'"
         [class.conversation-row-captain]="message.side === 'captain'"
         [class.conversation-row-note]="message.side === 'note'">
      <div class="conversation-bubble">
        <div class="conversation-meta">
          <strong>{{ message.speaker }}</strong>
          <span *ngIf="message.time">{{ message.time }}</span>
        </div>
        <div class="conversation-text">{{ message.text }}</div>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions class="button-flex">
  <button class="ok-btn font-size-13" (click)="onNoClick()">OK</button>
</div>
